import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {
  zadReportsAccountingUrl,
  zadReportsCashFlowUrl,
  zadReportsCustomerAccountsUrl,
  zadReportsDashboardUrl,
  zadReportsPurchasesUrl,
  zadReportsSalesUrl,
  zadReportsStockUrl,
  zadReportsSupplierAccountsUrl,
} from '../../api'
import {parseZadApiError} from '../zad/errors'
import {buildZadAccountingQuery, extractZadAccountingReport} from '../zad/accountingHelpers'
import {buildZadReportQuery} from '../zad/reportHelpers'
import {FetchZadReportRequest} from './types'

function reportUrl(base: string, payload?: FetchZadReportRequest) {
  const query = buildZadReportQuery(payload || {})
  return query ? `${base}?${query}` : base
}

export const fetchZadDashboardReport = createAsyncThunk(
  'zadReports/dashboard',
  async (payload: FetchZadReportRequest | void, {rejectWithValue}) => {
    try {
      const res = await axios.get(reportUrl(zadReportsDashboardUrl, payload || undefined))
      const data = res.data || {}
      return {success: true as const, report: data}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadSalesReport = createAsyncThunk(
  'zadReports/sales',
  async (payload: FetchZadReportRequest | void, {rejectWithValue}) => {
    try {
      const res = await axios.get(reportUrl(zadReportsSalesUrl, payload || undefined))
      const data = res.data || {}
      return {success: true as const, report: data}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadPurchasesReport = createAsyncThunk(
  'zadReports/purchases',
  async (payload: FetchZadReportRequest | void, {rejectWithValue}) => {
    try {
      const res = await axios.get(reportUrl(zadReportsPurchasesUrl, payload || undefined))
      const data = res.data || {}
      return {success: true as const, report: data}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadCustomerAccountsReport = createAsyncThunk(
  'zadReports/customerAccounts',
  async (payload: FetchZadReportRequest | void, {rejectWithValue}) => {
    try {
      const res = await axios.get(reportUrl(zadReportsCustomerAccountsUrl, payload || undefined))
      const data = res.data || {}
      return {success: true as const, report: data}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadSupplierAccountsReport = createAsyncThunk(
  'zadReports/supplierAccounts',
  async (payload: FetchZadReportRequest | void, {rejectWithValue}) => {
    try {
      const res = await axios.get(reportUrl(zadReportsSupplierAccountsUrl, payload || undefined))
      const data = res.data || {}
      return {success: true as const, report: data}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadStockReport = createAsyncThunk(
  'zadReports/stock',
  async (payload: FetchZadReportRequest | void, {rejectWithValue}) => {
    try {
      const res = await axios.get(reportUrl(zadReportsStockUrl, payload || undefined))
      const data = res.data || {}
      return {success: true as const, report: data}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadAccountingReport = createAsyncThunk(
  'zadReports/accounting',
  async (payload: {from: string; to: string}, {rejectWithValue}) => {
    try {
      const query = buildZadAccountingQuery(payload)
      const res = await axios.get(query ? `${zadReportsAccountingUrl}?${query}` : zadReportsAccountingUrl)
      const report = extractZadAccountingReport(res.data)
      return {success: true as const, report}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadCashFlowReport = createAsyncThunk(
  'zadReports/cashFlow',
  async (payload: FetchZadReportRequest | void, {rejectWithValue}) => {
    try {
      const res = await axios.get(reportUrl(zadReportsCashFlowUrl, payload || undefined))
      const data = res.data || {}
      return {success: true as const, report: data}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)
